<template>
    <div>

      <BCard no-body class="mb-0">
        <!-- Filters -->
        <div class="m-2">
          <BRow>
            <!-- Per Page -->
            <BCol cols="12" md="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
              <label>{{ $t('Show') }}</label>
              <vSelect v-model="perPage" :options="perPageOptions" :clearable="false" class="per-page-selector d-inline-block mx-50" />
              <label>{{$t('entries')}}</label>
            </BCol>

            <!-- Search -->
            <BCol cols="12" md="6">
              <div class="d-flex align-items-center justify-content-between">
                <!-- <BFormInput v-model="searchQuery" class="d-inline-block mr-1" :placeholder="$t('Search') + '...'"  /> -->
                <TextInputValidated :vsModel.sync="searchQuery" :vsCols="false" vsPlaceholder="Buscar ..." class="d-inline-block mr-1" />
                <BButton variant="primary" :to="{ name: 'families-add' }" v-if="ability.can('create', 'family')">
                  <span class="text-nowrap">{{$t('Add family')}}</span>
                </BButton>
              </div>
            </BCol>
          </BRow>
        </div>

        <!-- Table -->
        <BTable ref="refFamilyListTable" class="position-relative" :items="fetchFamilies" responsive :fields="tableColumns" primary-key="id" :sort-by.sync="sortBy" show-empty :empty-text="$t('No match records found')" :sort-desc.sync="isSortDirDesc">

          <template #cell(name)="data">
              {{ data.item.name }}
          </template>

          <template #cell(actions)="data">
            <BDropdown v-if="ability.can('write', 'family')" variant="link" no-caret :right="$store.state.appConfig.isRTL">

              <template #button-content>
                <feather-icon icon="MoreVerticalIcon" size="16" class="align-middle text-body" />
              </template>
              <!-- <BDropdownItem :to="{ name: 'families-view', params: { id: data.item.id } }" v-if="ability.can('read', 'family')">
                <feather-icon icon="FileTextIcon" />
                <span class="align-middle ml-50">{{$t('Details')}}</span>
              </BDropdownItem> -->

              <BDropdownItem :to="{ name: 'families-edit', params: { id: data.item.id } }" v-if="ability.can('write', 'family')">
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50">{{$t('Edit')}}</span>
              </BDropdownItem>

              <BDropdownItem @click="deletePopup(data.item.id, 'families/deleteFamily')" v-if="ability.can('delete', 'family')">
                <feather-icon icon="TrashIcon" />
                <span class="align-middle ml-50">{{$t('Delete')}}</span>
              </BDropdownItem>
            </BDropdown>
          </template>
        </BTable>

        <!-- Paginate -->
        <div class="mx-2 mb-2">
          <BRow>
            <BCol cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
              <span class="text-muted">{{$t('Showing')}} {{dataMeta.from}} {{$t('to')}} {{dataMeta.to}} {{$t('of')}} {{dataMeta.of}} {{$t('entries')}}</span>
            </BCol>
            <BCol cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
              <BPagination v-model="currentPage" :total-rows="totalFamilies" :per-page="perPage" first-number last-number class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </BPagination>
            </BCol>
          </BRow>
        </div>

      </BCard>
    </div>
  </template>

  <script>
  import { BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink, BBadge, BDropdown, BDropdownItem, BPagination,} from 'bootstrap-vue'
  import { onUnmounted } from '@vue/composition-api';
  import familiesListQuery from './familiesListQuery'
  import familyModule from '../familyModule'
  import ability from '@/libs/acl/ability'
  import popups from '@/hooks/popups'
  import vSelect  from 'vue-select'
  import store from '@/store'
  import TextInputValidated from '@/components/forms/TextInputValidated.vue'

  export default {
    components: { BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink, BBadge, BDropdown, BDropdownItem, BPagination, vSelect, TextInputValidated },
    setup(){
      const { fetchFamilies, tableColumns, perPage, currentPage, totalFamilies, dataMeta, perPageOptions, searchQuery, sortBy, isSortDirDesc, refFamilyListTable, refetchData } = familiesListQuery()
      const { deletePopup } = popups()
      const FAMILY_MODULE = 'families'

      if (!store.hasModule(FAMILY_MODULE)) store.registerModule(FAMILY_MODULE, familyModule)

      onUnmounted(() => {
        if(store.hasModule(FAMILY_MODULE)){
          store.unregisterModule(FAMILY_MODULE)
        }
      })

      return {
        fetchFamilies,
        tableColumns,
        perPage,
        currentPage,
        totalFamilies,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refFamilyListTable,
        refetchData,
        ability,
        deletePopup,
      }
    }
  }
  </script>

  <style lang="scss">
  @import '~@core/scss/vue/libs/vue-select.scss';
  </style>
